'use client';
import { MouseEvent } from 'react';
import { FooterLanguages, useBreakpoint } from 'components/pcc-components';
import {
  useParams,
  usePathname,
  useSearchParams,
  useRouter
} from 'next/navigation';
import { preventDefaultLinkEvent } from '@cat-ecom/common/utils/DOMUtils';
import { Language as PCCLanguage } from '@cat-ecom/pcc-components/src/components/footer/footer-languages/FooterLanguages';
import { useHash } from 'hooks/use-url-hash';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const LanguageClientLinks = ({
  langId,
  languages,
  isMobileFooterDesignupdate
}: {
  languages: PCCLanguage[] | Language[];
  langId: string;
  isMobileFooterDesignupdate: boolean;
}) => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');.
  const { lang }: esiteParams = useParams();
  /*  TODO - Input Validations - usePathName: Validate pathname is a valid
  string with alphanumeric values allowin only two special characters . Slash (/)
  and Dash (-) . UNDER INVESTIGATION - All valid part number characters*/
  const pathname = usePathname();
  const search = useSearchParams().toString();
  const router = useRouter();
  const hash = useHash();
  const isMd = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const hashString = hash ? `#${hash}` : '';
  const searchString = search ? `?${search}` : '';
  const languageHref = ({ seoToken }) =>
    `${pathname.replace(lang, seoToken)}${searchString}${hashString}`;

  const languageLinksMap = languages.map((language) => ({
    ...language,
    localeName: language.locale,
    nativeDescriptionString: language.nativeDescription,
    href: languageHref(language)
  }));

  const onClickHandler = (event: MouseEvent, language: PCCLanguage) => {
    if (preventDefaultLinkEvent(event)) {
      router.push(language.href);
    }
  };

  return (
    <FooterLanguages
      langId={langId}
      isMobile={!isMd}
      isMobileFooterDesignUpdate={isMobileFooterDesignupdate}
      languages={languageLinksMap}
      onClick={onClickHandler}
    />
  );
};
